/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iframe_Remote_Transcript_Imported_MessageInputs */



/**
* | output |
* | --- |
* | "Transcript imported successfully" |
*
* @param {Iframe_Remote_Transcript_Imported_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_transcript_imported_message = /** @type {((inputs?: Iframe_Remote_Transcript_Imported_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Transcript_Imported_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Transcription importee avec succes")
	if (locale === "de") return /** @type {LocalizedString} */ ("Transkript erfolgreich importiert")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trascrizione importata con successo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Текст успешно импортирован.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Transcripción importada exitosamente")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("成绩单导入成功")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトが正常にインポートされました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेख सफलतापूर्वक आयात हो गया")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Transcrição importada com sucesso")
	return /** @type {LocalizedString} */ ("Transcript imported successfully")
});